export const ELI_ELY = {
  title: 'ELI & ELY: THE SPLIT PART ONE',
  slug: 'eli-and-ely-the-split-part-one',
  image: '/u99/eli-ely-character-map.png',
  familyVibes: "Blood isn't always who raises you. Family is who shows up.",
  extraNotes: [
    'Uncle Marcus is the stability Eli needs.',
    'Aunty Tanya is the love that heals.',
    'They give Eli and Emily space, freedom, boundaries and belief.',
    "Their home in Sacramento is Eli's reset... a chance to build something different.",
  ],
  theirWorld: ['Boat Days', 'Good Music', 'Home Comforts', 'Family Dinners', 'Late Night Talks'],
  whatMatters: ['Loyalty over everything', 'Freedom with responsibility', 'Love without conditions', 'Truth, honesty and respect', 'Protect the good people'],
  characters: [
    {
      id: 'eli', name: 'ELI', alias: '', color: '#FBBF24',
      facts: [['Soul role', 'The big brother who would move heaven and earth for Emily.']],
      is: [], role: '', polaroids: [],
    },
    {
      id: 'emily', name: 'EMILY', alias: '“EMMY BOCCA”', color: '#F472B6',
      facts: [
        ['Born', '1993'],
        ['Age gap', '7 years younger than Eli'],
        ['Nature', 'Bright • Playful • Sensitive'],
        ['Energy', 'Pure • Curious • Innocent'],
        ['Soul role', "Eli's heart. The one he protects, guides and would move heaven and earth for."],
        ['Loves', 'Animals, cartoons, dancing, sparkles, stories, her big brother.'],
      ],
      is: ['The light in the darker days', 'Empathic and feels everything', 'Fiercely loyal', 'Loves hard and forgives easy', 'Sees the good'],
      role: "To remind Eli what's worth fighting for. The reason he keeps going.",
      polaroids: ['Cheeky', 'Animal Lover', 'Little Dancer', 'Bedtime Stories', "Big Brother's Girl"],
    },
    {
      id: 'marcus', name: 'UNCLE', alias: '(MARCUS)', color: '#38BDF8',
      facts: [
        ['Role', 'Protector. Provider. Safe place.'],
        ['Nature', 'Calm • Loyal • Fair'],
        ['Strength', "Steady presence. Sees Eli's potential."],
        ['Energy', 'Laid-back but sharp when it matters.'],
        ['Loves', 'Family, Boating, Music, Good coffee, Freedom.'],
      ],
      is: [], role: '',
      polaroids: ['Boating', 'Trusted Mentor', 'Music Man', 'Always There'],
    },
    {
      id: 'tanya', name: 'AUNTY', alias: '(TANYA)', color: '#C084FC',
      facts: [
        ['Role', 'Warmth, Nurturer, Home'],
        ['Nature', 'Loving • Grounded • Wise'],
        ['Strength', 'Intuition, Kindness, Keeps the peace.'],
        ['Energy', 'Healing • Comforting • Supportive'],
        ['Loves', 'Cooking, Nature, Candles, Animals, Deep talks.'],
      ],
      is: ['The heart of the home', 'Makes everyone feel safe', 'Listens without judgement', 'Loves fiercely', 'Sees the good'],
      role: 'To love Eli and Emily like her own and help them heal.',
      polaroids: ['Home Cook', 'Animal Lover', 'Nature Soul', 'Heart Listener', 'Family Time'],
    },
  ],
};
